import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const UseCreateUser = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("User/createUser", formData);
  });
  return mutation;
};
export default UseCreateUser;
